<template>
  <div class="px-2 game-score text-center">
    <div class="position-relative" v-if="game.ScoreTeam1 > game.ScoreTeam2">
      <div class="text-nowrap">
        <span v-if="game.TeamOvertimeWin > 0 && game.Team1_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
        <span :class="dataSport.textClass">{{game.ScoreTeam1}}</span>
        <span class="separator text-white">-</span>
        <span class="text-white">{{game.ScoreTeam2}}</span>
        <span v-if="game.TeamOvertimeWin > 0 && game.Team2_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
      </div>
    </div>
    <div class="position-relative" v-else-if="game.ScoreTeam1 < game.ScoreTeam2">
      <div class="text-nowrap">
        <span v-if="game.TeamOvertimeWin > 0 && game.Team1_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
        <span class="text-white">{{game.ScoreTeam1}}</span>
        <span class="separator text-white">-</span>
        <span :class="dataSport.textClass">{{game.ScoreTeam2}}</span>
        <span v-if="game.TeamOvertimeWin > 0 && game.Team2_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
      </div>
    </div>
    <div class="position-relative" v-else-if="game.ScoreTeam1 === game.ScoreTeam2 && game.State !== 'upcoming'">
      <div class="text-nowrap">
        <span v-if="game.TeamBullitsWin > 0 && game.Team1_id === game.TeamBullitsWin" :class="dataSport.textClass">Б&nbsp;</span>
        <span class="text-white">{{game.ScoreTeam1}}</span>
        <span class="separator text-white">-</span>
        <span class="text-white">{{game.ScoreTeam2}}</span>
        <span v-if="game.TeamBullitsWin > 0 && game.Team2_id === game.TeamBullitsWin" :class="dataSport.textClass">&nbsp;Б</span>
      </div>
    </div>
    <div v-else>
      <b class="separator text-white">-</b>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MlbGameScore",
    props: ['game','dataSport'],
  }
</script>

<style scoped>
  .game-score {
    letter-spacing: 2px;
    font-size: 0.8rem;
  }
</style>